import { TableCell } from 'ui/tableCell';
import { FlexSpacer } from 'ui/flexSpacer';
import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { colors } from 'ui/theme/colors';
import type { StatusCellProps } from '../types';

export const StatusCell = ({
  negativeLabel = 'No',
  positiveLabel = 'Yes',
  showPositiveState,
  ...props
}: StatusCellProps) => {
  const Icon = showPositiveState ? (
    <PositiveFill color={colors.green100} />
  ) : (
    <NegativeFillDiamond color={colors.iconSubtle} />
  );
  const label = showPositiveState ? positiveLabel : negativeLabel;

  return (
    <TableCell {...props}>
      <FlexSpacer gap="quarter" alignItems="center">
        {Icon}
        <div>{label}</div>
      </FlexSpacer>
    </TableCell>
  );
};
